import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e22a890"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "closefriend-hero background-white" }
const _hoisted_2 = { class: "container mt-5" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "tab-content w-100" }
const _hoisted_5 = { class: "my-4 mx-4 p-0 bg-white border-radius-10" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row m-0 bg-card-light",
  style: {"border-radius":"10px 10px 0px 0px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 d-flex justify-content-center py-4" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "font-grey p-cursor text-center" }, [
      /*#__PURE__*/_createElementVNode("b", { style: {"color":"#6B7A99"} }, "Government Bodies Application")
    ])
  ])
], -1))
const _hoisted_7 = { class: "row my-3 justify-content-center" }
const _hoisted_8 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2" }
const _hoisted_9 = { class: "container-fluid" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "list-unstyled multi-steps" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Personal", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Business", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "External Bank Account", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "E-Signature", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Upload Proof", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "row my-3 justify-content-center" }
const _hoisted_24 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2" }
const _hoisted_25 = { class: "login-card" }
const _hoisted_26 = { class: "login-body company" }
const _hoisted_27 = { class: "row mt-3" }
const _hoisted_28 = { class: "col-md-12 col-12" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, [
  /*#__PURE__*/_createTextVNode(" Ref No"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("small", null, "If you have been given a Ref number by Caprock please enter it here.")
], -1))
const _hoisted_31 = { class: "col-md-12 col-12" }
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, [
  /*#__PURE__*/_createTextVNode(" Advisor Ref No"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("small", null, "If you have been given a Advisor Ref number by Caprock please enter it here.")
], -1))
const _hoisted_34 = { class: "col-md-12 col-12" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Profile Picture", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = ["src"]
const _hoisted_39 = {
  key: 3,
  class: "progress"
}
const _hoisted_40 = ["aria-valuenow"]
const _hoisted_41 = { class: "col-md-12 col-12" }
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Full name of the government body", -1))
const _hoisted_44 = { class: "col-md-12 col-12" }
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Full address of the government body's principal place of operations", -1))
const _hoisted_47 = { class: "form-group place_suggest_pr_a d-none" }
const _hoisted_48 = {
  class: "card place_suggest_pr_a",
  style: {"max-width":"100%","overflow-y":"scroll","max-height":"250px"}
}
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["id"]
const _hoisted_51 = { style: {"font-weight":"600","cursor":"pointer"} }
const _hoisted_52 = {
  class: "p-0 m-0",
  style: {"color":"grey","cursor":"pointer"}
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1))
const _hoisted_54 = { class: "col-md-12 col-12" }
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Applicant's country", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_58 = ["value"]
const _hoisted_59 = { class: "col-md-12 col-12" }
const _hoisted_60 = { class: "form-group" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Any alias names used by the member of the government body", -1))
const _hoisted_62 = { class: "col-md-12 col-12" }
const _hoisted_63 = { class: "form-group" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Investment Currency", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_66 = ["value"]
const _hoisted_67 = { class: "col-md-12 col-12" }
const _hoisted_68 = { class: "form-group" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Expected investment amount", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "$500k-$50 million" }, "$500k-$50 million", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "$50-$100 million" }, "$50-$100 million", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "$100 million +" }, "$100 million +", -1))
const _hoisted_74 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_75 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_76 = { class: "col-3 px-1" }
const _hoisted_77 = { class: "col-3 px-1" }
const _hoisted_78 = { class: "col-3 px-1" }
const _hoisted_79 = { class: "row my-3 justify-content-center" }
const _hoisted_80 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_81 = { class: "login-card" }
const _hoisted_82 = { class: "login-body business" }
const _hoisted_83 = { class: "row mt-3" }
const _hoisted_84 = { class: "col-md-12 col-12" }
const _hoisted_85 = { class: "form-group" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "GOVERNMENT BODIES ASSESSMENT NATURE", -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Australian", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Foreign", -1))
const _hoisted_90 = { class: "col-md-12 col-12" }
const _hoisted_91 = { class: "form-group" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Business Nature (Major business)", -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Accredited Investor", -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "High Net-worth Individual", -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Sophisticated Investor", -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "4" }, "Wholesale Investor", -1))
const _hoisted_98 = { class: "col-md-12 col-12" }
const _hoisted_99 = { class: "form-group" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Government Bodies’s business activities", -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Capital Markets", -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Commodities", -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Financial Markets", -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "4" }, "Others", -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "5" }, "Real Estate", -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "6" }, "Stock Market", -1))
const _hoisted_108 = {
  key: 0,
  class: "col-md-12 col-12"
}
const _hoisted_109 = { class: "form-group" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Please mention business activity", -1))
const _hoisted_111 = { class: "col-md-12 col-12" }
const _hoisted_112 = { class: "form-group" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Source of the government body’s funds including the origin of funds, including beneficial ownership", -1))
const _hoisted_114 = { class: "col-md-12 col-12" }
const _hoisted_115 = { class: "form-group" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Income and assets of the government body", -1))
const _hoisted_117 = { class: "col-md-12 col-12" }
const _hoisted_118 = { class: "form-group" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Nature and level of the government body’s intended transaction behaviour", -1))
const _hoisted_120 = { class: "col-md-12 col-12" }
const _hoisted_121 = { class: "form-group" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Beneficial ownership of the funds used by the member/the government body’s account with Caprock", -1))
const _hoisted_123 = {
  key: 1,
  class: "col-md-12 col-12"
}
const _hoisted_124 = { class: "form-group" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Is the Government Body an entity or emanation, or is established under legislation of the Commonwealth ?", -1))
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "is_under_commonwealth0"
}, " Yes ", -1))
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "is_under_commonwealth1"
}, " No ", -1))
const _hoisted_129 = {
  key: 2,
  class: "col-md-12 col-12"
}
const _hoisted_130 = { class: "form-group" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Is the Government Body an Entity or Emanation or is established under State or Territory Legislation ?", -1))
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "is_under_legislation0"
}, " Yes ", -1))
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "is_under_legislation1"
}, " No ", -1))
const _hoisted_135 = {
  key: 3,
  class: "col-md-12 col-12"
}
const _hoisted_136 = { class: "form-group" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name the State or Territory", -1))
const _hoisted_138 = {
  key: 4,
  class: "col-md-12 col-12"
}
const _hoisted_139 = { class: "form-group" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Is the Government Body an entity or emanation, or is established under legislation of the Foreign Country ?", -1))
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "is_under_legislation_foreign0"
}, " Yes ", -1))
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "is_under_legislation_foreign1"
}, " No ", -1))
const _hoisted_144 = {
  key: 5,
  class: "col-md-12 col-12"
}
const _hoisted_145 = { class: "form-group" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name the Foreign Country", -1))
const _hoisted_147 = {
  key: 6,
  class: "col-md-12 col-12"
}
const _hoisted_148 = { class: "form-group" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name the State or Territory", -1))
const _hoisted_150 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_151 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_152 = { class: "col-3 px-1" }
const _hoisted_153 = { class: "col-3 px-1" }
const _hoisted_154 = { class: "col-3 px-1" }
const _hoisted_155 = { class: "row my-3 justify-content-center" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "login-card" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "login-body company" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "row mt-3" })
    ])
  ])
], -1))
const _hoisted_157 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_158 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_159 = { class: "col-3 px-1" }
const _hoisted_160 = { class: "col-3 px-1" }
const _hoisted_161 = { class: "row my-3 justify-content-center" }
const _hoisted_162 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_163 = { class: "login-card" }
const _hoisted_164 = { class: "login-body company" }
const _hoisted_165 = { class: "row mt-3" }
const _hoisted_166 = { class: "col-md-12 col-12" }
const _hoisted_167 = { class: "form-group" }
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name", -1))
const _hoisted_169 = { class: "col-md-12 col-12" }
const _hoisted_170 = { class: "form-group" }
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Email", -1))
const _hoisted_172 = { class: "col-md-12 col-12" }
const _hoisted_173 = { class: "form-group" }
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Phone Number", -1))
const _hoisted_175 = { class: "col-md-12 col-12" }
const _hoisted_176 = { class: "form-group" }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Date of Birth", -1))
const _hoisted_178 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_179 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_180 = { class: "col-3 px-1" }
const _hoisted_181 = { class: "col-3 px-1" }
const _hoisted_182 = { class: "col-3 px-1" }
const _hoisted_183 = { class: "row my-3 justify-content-center" }
const _hoisted_184 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_185 = { class: "login-card" }
const _hoisted_186 = { class: "login-body company" }
const _hoisted_187 = { class: "row mt-3" }
const _hoisted_188 = { class: "form-group" }
const _hoisted_189 = { class: "font-grey" }
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_191 = ["onClick"]
const _hoisted_192 = ["innerHTML"]
const _hoisted_193 = {
  key: 3,
  class: "progress"
}
const _hoisted_194 = ["aria-valuenow"]
const _hoisted_195 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_196 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_197 = { class: "col-3 px-1" }
const _hoisted_198 = { class: "col-3 px-1" }
const _hoisted_199 = { class: "col-3 px-1" }
const _hoisted_200 = {
  class: "modal fade cancel_request",
  id: "cancel_request",
  role: "dialog"
}
const _hoisted_201 = {
  class: "modal-dialog modal-md modal-dialog-centered",
  role: "document"
}
const _hoisted_202 = { class: "modal-content" }
const _hoisted_203 = { class: "modal-body mb-2" }
const _hoisted_204 = { class: "row mx-1 mt-1" }
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"larger"} }, "Cancelling will delete all details entered.")
], -1))
const _hoisted_206 = { class: "col-md-12 text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Banks = _resolveComponent("Banks")!
  const _component_toasti = _resolveComponent("toasti")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic, { load_on: _ctx.load_on }, null, 8, ["load_on"]),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _hoisted_11,
                    _createElementVNode("ul", _hoisted_12, [
                      _createElementVNode("li", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.set_step(1);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='personal'}])
                      }, _hoisted_14, 2),
                      _createElementVNode("li", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.set_step(2);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='business'}])
                      }, _hoisted_16, 2),
                      _createElementVNode("li", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.set_step(3);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='account'}])
                      }, _hoisted_18, 2),
                      _createElementVNode("li", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.set_step(4);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='e_signature'}])
                      }, _hoisted_20, 2),
                      (_ctx.final_step==5)
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 0,
                            onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.set_step(5);}),
                            class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='upload'}])
                          }, _hoisted_22, 2))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              (this.current_step==1)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 0,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_1
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createVNode(_component_Field, {
                                  modelValue: this.active_tab,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((this.active_tab) = $event)),
                                  name: "user_type",
                                  id: "user_type",
                                  type: "hidden"
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _hoisted_30,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.user_ref_no,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.user_ref_no) = $event)),
                                      placeholder: "ie. CM0011114",
                                      class: "form-control selected-field",
                                      name: "user_ref_no",
                                      id: "user_ref_no",
                                      type: "text",
                                      readonly: ""
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "user_ref_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("div", _hoisted_32, [
                                    _hoisted_33,
                                    _createVNode(_component_Field, {
                                      readonly: _ctx.advisor_exist==1,
                                      modelValue: _ctx.form.advisor_ref_no,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.advisor_ref_no) = $event)),
                                      placeholder: "ie. A042",
                                      class: "form-control selected-field",
                                      name: "advisor_ref_no",
                                      id: "advisor_ref_no",
                                      type: "text"
                                    }, null, 8, ["readonly", "modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "advisor_ref_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("div", _hoisted_35, [
                                    _hoisted_36,
                                    _hoisted_37,
                                    (typeof _ctx.records.profile_pic_url!='undefined' && _ctx.records.profile_pic_url!='')
                                      ? (_openBlock(), _createBlock(_component_Field, {
                                          key: 0,
                                          onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.uploadFile($event))),
                                          modelValue: _ctx.form.profile_pic,
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.profile_pic) = $event)),
                                          class: "form-control selected-field",
                                          name: "profile_pic",
                                          type: "file"
                                        }, null, 8, ["modelValue"]))
                                      : _createCommentVNode("", true),
                                    (typeof _ctx.records.profile_pic_url=='undefined' || _ctx.records.profile_pic_url=='')
                                      ? (_openBlock(), _createBlock(_component_Field, {
                                          key: 1,
                                          onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.uploadFile($event))),
                                          modelValue: _ctx.form.profile_pic,
                                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.profile_pic) = $event)),
                                          class: "form-control selected-field",
                                          name: "profile_pic",
                                          type: "file",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "profile_pic"
                                    }),
                                    (typeof _ctx.records.profile_pic_url!='undefined' && _ctx.records.profile_pic_url!='')
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 2,
                                          class: "p-cursor",
                                          onClick: _cache[12] || (_cache[12] = ($event: any) => {_ctx.openDoc(_ctx.records.profile_pic_url);})
                                        }, [
                                          _createElementVNode("img", {
                                            class: "rounded-circle",
                                            style: {"height":"50px"},
                                            src: _ctx.records.profile_pic_url
                                          }, null, 8, _hoisted_38)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.form['profile_pic_pdiv']==1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                          _createElementVNode("div", {
                                            class: "progress-bar bg-dark",
                                            role: "progressbar",
                                            style: _normalizeStyle({'width':_ctx.form['profile_pic_pbar']+'%'}),
                                            "aria-valuenow": _ctx.form['profile_pic_pbar'],
                                            "aria-valuemin": "0",
                                            "aria-valuemax": "100"
                                          }, _toDisplayString(_ctx.form['profile_pic_pbar_p']), 13, _hoisted_40)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_Field, {
                                      rules: _ctx.requiredField,
                                      modelValue: _ctx.form['profile_pic_path'],
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form['profile_pic_path']) = $event)),
                                      class: "form-control selected-field",
                                      name: "profile_pic_path",
                                      type: "hidden"
                                    }, null, 8, ["rules", "modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "profile_pic_path"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_41, [
                                  _createElementVNode("div", _hoisted_42, [
                                    _hoisted_43,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.full_name,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.full_name) = $event)),
                                      class: "form-control selected-field",
                                      name: "full_name",
                                      placeholder: "Full name of the government body",
                                      type: "text",
                                      rules: [_ctx.requiredField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "full_name"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("div", _hoisted_45, [
                                    _hoisted_46,
                                    _createVNode(_component_Field, {
                                      onKeyup: _cache[15] || (_cache[15] = ($event: any) => {_ctx.textSearch($event,'_pr_a');}),
                                      onfocus: "this.setAttribute('autocomplete', 'disable-autocomplete');",
                                      autocomplete: "off",
                                      modelValue: _ctx.form.principal_address,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.principal_address) = $event)),
                                      class: "form-control selected-field",
                                      name: "principal_address",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "principal_address"
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_47, [
                                    _createElementVNode("div", _hoisted_48, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.place_list, (item) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: item.id,
                                          onClick: ($event: any) => {_ctx.set_address(item.id,'principal_address','_pr_a');},
                                          class: "suggestDiv_pr_a"
                                        }, [
                                          _createElementVNode("div", {
                                            class: "d-none",
                                            id: 'addr_'+item.id
                                          }, _toDisplayString(item.address), 9, _hoisted_50),
                                          _createElementVNode("h6", _hoisted_51, _toDisplayString(item.title), 1),
                                          _createElementVNode("p", _hoisted_52, _toDisplayString(item.details), 1)
                                        ], 8, _hoisted_49))
                                      }), 128)),
                                      _hoisted_53
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_54, [
                                  _createElementVNode("div", _hoisted_55, [
                                    _hoisted_56,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.applicant_country,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.applicant_country) = $event)),
                                      class: "form-control",
                                      name: "applicant_country",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_57,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: country.country_id,
                                            value: country.country_id
                                          }, _toDisplayString(country.country_name), 9, _hoisted_58))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "applicant_country"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_59, [
                                  _createElementVNode("div", _hoisted_60, [
                                    _hoisted_61,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.alias_name,
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.alias_name) = $event)),
                                      class: "form-control selected-field",
                                      name: "alias_name",
                                      placeholder: "Alias name used by member",
                                      type: "text",
                                      rules: [_ctx.requiredField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "alias_name"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_62, [
                                  _createElementVNode("div", _hoisted_63, [
                                    _hoisted_64,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.investment_currency,
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.investment_currency) = $event)),
                                      class: "form-control",
                                      name: "investment_currency",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_65,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: country.country_id,
                                            value: country.country_id
                                          }, _toDisplayString(country.currency) + " - " + _toDisplayString(country.country_name), 9, _hoisted_66))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "investment_currency"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_67, [
                                  _createElementVNode("div", _hoisted_68, [
                                    _hoisted_69,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.investment_amount,
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.investment_amount) = $event)),
                                      class: "form-control",
                                      name: "investment_amount",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_70,
                                        _hoisted_71,
                                        _hoisted_72,
                                        _hoisted_73
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "investment_amount"
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("div", _hoisted_75, [
                            _createElementVNode("div", _hoisted_76, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_77, [
                              _createElementVNode("button", {
                                onClick: _cache[22] || (_cache[22] = ($event: any) => {_ctx.next_step=1;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_78, [
                              _createElementVNode("button", {
                                onClick: _cache[23] || (_cache[23] = ($event: any) => {_ctx.next_step=2;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==2)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 1,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_2
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("div", _hoisted_81, [
                            _createElementVNode("div", _hoisted_82, [
                              _createElementVNode("div", _hoisted_83, [
                                _createElementVNode("div", _hoisted_84, [
                                  _createElementVNode("div", _hoisted_85, [
                                    _hoisted_86,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.govtbodies_nature,
                                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.govtbodies_nature) = $event)),
                                      class: "form-control",
                                      name: "govtbodies_nature",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_87,
                                        _hoisted_88,
                                        _hoisted_89
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "govtbodies_nature"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_90, [
                                  _createElementVNode("div", _hoisted_91, [
                                    _hoisted_92,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.business_nature,
                                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.business_nature) = $event)),
                                      class: "form-control",
                                      name: "business_nature",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_93,
                                        _hoisted_94,
                                        _hoisted_95,
                                        _hoisted_96,
                                        _hoisted_97
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "business_nature"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_98, [
                                  _createElementVNode("div", _hoisted_99, [
                                    _hoisted_100,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.business_activity,
                                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.business_activity) = $event)),
                                      class: "form-control",
                                      name: "business_activity",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_101,
                                        _hoisted_102,
                                        _hoisted_103,
                                        _hoisted_104,
                                        _hoisted_105,
                                        _hoisted_106,
                                        _hoisted_107
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "business_activity"
                                    })
                                  ])
                                ]),
                                (_ctx.form.business_activity==4)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                      _createElementVNode("div", _hoisted_109, [
                                        _hoisted_110,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.business_activity_other,
                                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.business_activity_other) = $event)),
                                          class: "form-control selected-field",
                                          name: "business_activity_other",
                                          placeholder: "ie. IT Services",
                                          type: "text",
                                          rules: [_ctx.requiredField]
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "business_activity_other"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_111, [
                                  _createElementVNode("div", _hoisted_112, [
                                    _hoisted_113,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.funding_source,
                                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.funding_source) = $event)),
                                      class: "form-control selected-field",
                                      name: "funding_source",
                                      placeholder: "",
                                      type: "text",
                                      rules: [_ctx.requiredField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "funding_source"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_114, [
                                  _createElementVNode("div", _hoisted_115, [
                                    _hoisted_116,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.income_asset,
                                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.income_asset) = $event)),
                                      class: "form-control selected-field",
                                      name: "income_asset",
                                      placeholder: "",
                                      type: "text",
                                      rules: [_ctx.requiredField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "income_asset"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_117, [
                                  _createElementVNode("div", _hoisted_118, [
                                    _hoisted_119,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.transaction_behaviour,
                                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.transaction_behaviour) = $event)),
                                      class: "form-control selected-field",
                                      name: "transaction_behaviour",
                                      placeholder: "",
                                      type: "text",
                                      rules: [_ctx.requiredField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "transaction_behaviour"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_120, [
                                  _createElementVNode("div", _hoisted_121, [
                                    _hoisted_122,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.beneficial_ownership,
                                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.beneficial_ownership) = $event)),
                                      class: "form-control selected-field",
                                      name: "beneficial_ownership",
                                      placeholder: "",
                                      type: "text",
                                      rules: [_ctx.requiredField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficial_ownership"
                                    })
                                  ])
                                ]),
                                (_ctx.form.govtbodies_nature==1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                                      _createElementVNode("div", _hoisted_124, [
                                        _hoisted_125,
                                        _createTextVNode(),
                                        _hoisted_126,
                                        _createVNode(_component_Field, {
                                          id: "is_under_commonwealth0",
                                          modelValue: _ctx.form.is_under_commonwealth,
                                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.form.is_under_commonwealth) = $event)),
                                          class: "mx-2",
                                          name: "is_under_commonwealth",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "1"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_127,
                                        _createVNode(_component_Field, {
                                          id: "is_under_commonwealth1",
                                          modelValue: _ctx.form.is_under_commonwealth,
                                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.form.is_under_commonwealth) = $event)),
                                          class: "ml-4 mx-2",
                                          name: "is_under_commonwealth",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "0"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_128,
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "is_under_commonwealth"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.govtbodies_nature==1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                                      _createElementVNode("div", _hoisted_130, [
                                        _hoisted_131,
                                        _createTextVNode(),
                                        _hoisted_132,
                                        _createVNode(_component_Field, {
                                          id: "is_under_legislation0",
                                          modelValue: _ctx.form.is_under_legislation,
                                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.form.is_under_legislation) = $event)),
                                          class: "mx-2",
                                          name: "is_under_legislation",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "1"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_133,
                                        _createVNode(_component_Field, {
                                          id: "is_under_legislation1",
                                          modelValue: _ctx.form.is_under_legislation,
                                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.form.is_under_legislation) = $event)),
                                          class: "ml-4 mx-2",
                                          name: "is_under_legislation",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "0"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_134,
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "is_under_legislation"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.govtbodies_nature==1 && _ctx.form.is_under_legislation==1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                                      _createElementVNode("div", _hoisted_136, [
                                        _hoisted_137,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.state_territory,
                                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.form.state_territory) = $event)),
                                          class: "form-control selected-field",
                                          name: "state_territory",
                                          placeholder: "State or Territory",
                                          type: "text",
                                          rules: [_ctx.requiredField]
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "state_territory"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.govtbodies_nature==2)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                      _createElementVNode("div", _hoisted_139, [
                                        _hoisted_140,
                                        _createTextVNode(),
                                        _hoisted_141,
                                        _createVNode(_component_Field, {
                                          id: "is_under_legislation_foreign0",
                                          modelValue: _ctx.form.is_under_legislation_foreign,
                                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.form.is_under_legislation_foreign) = $event)),
                                          class: "mx-2",
                                          name: "is_under_legislation_foreign",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "1"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_142,
                                        _createVNode(_component_Field, {
                                          id: "is_under_legislation_foreign1",
                                          modelValue: _ctx.form.is_under_legislation_foreign,
                                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.form.is_under_legislation_foreign) = $event)),
                                          class: "ml-4 mx-2",
                                          name: "is_under_legislation_foreign",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "0"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_143,
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "is_under_legislation_foreign"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.govtbodies_nature==2)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                                      _createElementVNode("div", _hoisted_145, [
                                        _hoisted_146,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.foreign_country,
                                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.form.foreign_country) = $event)),
                                          class: "form-control selected-field",
                                          name: "foreign_country",
                                          placeholder: "Country name",
                                          type: "text",
                                          rules: [_ctx.requiredField]
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "foreign_country"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.govtbodies_nature==2)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                                      _createElementVNode("div", _hoisted_148, [
                                        _hoisted_149,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.state_territory,
                                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.form.state_territory) = $event)),
                                          class: "form-control selected-field",
                                          name: "state_territory",
                                          placeholder: "State or Territory",
                                          type: "text",
                                          rules: [_ctx.requiredField]
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "state_territory"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_150, [
                          _createElementVNode("div", _hoisted_151, [
                            _createElementVNode("div", _hoisted_152, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_153, [
                              _createElementVNode("button", {
                                onClick: _cache[42] || (_cache[42] = ($event: any) => {_ctx.next_step=2;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_154, [
                              _createElementVNode("button", {
                                onClick: _cache[43] || (_cache[43] = ($event: any) => {_ctx.next_step=3;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==3)
                ? (_openBlock(), _createBlock(_component_Banks, {
                    key: 2,
                    countries: _ctx.countries,
                    current_step: _ctx.current_step,
                    load_on: _ctx.load_on
                  }, null, 8, ["countries", "current_step", "load_on"]))
                : _createCommentVNode("", true),
              (this.current_step==3)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 3,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_3
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_155, [
                        _hoisted_156,
                        _createElementVNode("div", _hoisted_157, [
                          _createElementVNode("div", _hoisted_158, [
                            _createElementVNode("div", _hoisted_159, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_160, [
                              _createElementVNode("button", {
                                onClick: _cache[45] || (_cache[45] = ($event: any) => {_ctx.next_step=4;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==4)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 4,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_4
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_161, [
                        _createElementVNode("div", _hoisted_162, [
                          _createElementVNode("div", _hoisted_163, [
                            _createElementVNode("div", _hoisted_164, [
                              _createElementVNode("div", _hoisted_165, [
                                _createElementVNode("div", _hoisted_166, [
                                  _createElementVNode("div", _hoisted_167, [
                                    _hoisted_168,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_name,
                                      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.form.esign_name) = $event)),
                                      placeholder: "i.e. Jonaten ",
                                      class: "form-control selected-field",
                                      name: "esign_name",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_name"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_169, [
                                  _createElementVNode("div", _hoisted_170, [
                                    _hoisted_171,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_email_id,
                                      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.form.esign_email_id) = $event)),
                                      placeholder: "i.e. email@address.com  ",
                                      class: "form-control selected-field",
                                      name: "esign_email_id",
                                      type: "text",
                                      rules: [_ctx.requiredField,_ctx.validateEmail]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_email_id"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_172, [
                                  _createElementVNode("div", _hoisted_173, [
                                    _hoisted_174,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_phone_no,
                                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.form.esign_phone_no) = $event)),
                                      placeholder: "i.e. 3539 000556  ",
                                      class: "form-control selected-field",
                                      name: "esign_phone_no",
                                      type: "text",
                                      rules: [_ctx.requiredField,_ctx.mobileField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_phone_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_175, [
                                  _createElementVNode("div", _hoisted_176, [
                                    _hoisted_177,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_dob,
                                      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.form.esign_dob) = $event)),
                                      class: "form-control selected-field",
                                      name: "esign_dob",
                                      type: "date",
                                      rules: _ctx.requiredField,
                                      onclick: "this.type='date'",
                                      onfocus: "this.type='date';",
                                      onblur: "(typeof this.value!='undefined' && this.value!='' && this.value!=null) ? this.type='date' : this.type='text'",
                                      placeholder: "D.O.B"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_dob"
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_178, [
                          _createElementVNode("div", _hoisted_179, [
                            _createElementVNode("div", _hoisted_180, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_181, [
                              _createElementVNode("button", {
                                onClick: _cache[51] || (_cache[51] = ($event: any) => {_ctx.next_step=4;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_182, [
                              _createElementVNode("button", {
                                onClick: _cache[52] || (_cache[52] = ($event: any) => {_ctx.next_step=5;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==5  && _ctx.final_step==5)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 5,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_5
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_183, [
                        _createElementVNode("div", _hoisted_184, [
                          _createElementVNode("div", _hoisted_185, [
                            _createElementVNode("div", _hoisted_186, [
                              _createElementVNode("div", _hoisted_187, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.final_docs, (upload_doc) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "col-md-12 col-12",
                                    key: upload_doc.input_name
                                  }, [
                                    _createElementVNode("div", _hoisted_188, [
                                      _createElementVNode("label", _hoisted_189, _toDisplayString(upload_doc.name), 1),
                                      _hoisted_190,
                                      (typeof _ctx.records[upload_doc.input_name+'_url']!='undefined' && _ctx.records[upload_doc.input_name+'_url']!='')
                                        ? (_openBlock(), _createBlock(_component_Field, {
                                            key: 0,
                                            onChange: _cache[53] || (_cache[53] = ($event: any) => (_ctx.uploadFile($event))),
                                            modelValue: _ctx.form.driver_license,
                                            "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.form.driver_license) = $event)),
                                            class: "form-control selected-field",
                                            name: "driver_license",
                                            type: "file"
                                          }, null, 8, ["modelValue"]))
                                        : _createCommentVNode("", true),
                                      (typeof _ctx.records[upload_doc.input_name+'_url']=='undefined' || _ctx.records[upload_doc.input_name+'_url']=='')
                                        ? (_openBlock(), _createBlock(_component_Field, {
                                            key: 1,
                                            onChange: _cache[55] || (_cache[55] = ($event: any) => (_ctx.uploadFile($event))),
                                            modelValue: _ctx.form[upload_doc.input_name],
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.form[upload_doc.input_name]) = $event),
                                            class: "form-control selected-field",
                                            name: upload_doc.input_name,
                                            type: "file",
                                            rules: _ctx.requiredField
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "rules"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_ErrorMessage, {
                                        style: {"color":"#d00000"},
                                        name: upload_doc.input_name
                                      }, null, 8, ["name"]),
                                      (typeof _ctx.records[upload_doc.input_name+'_url']!='undefined' && _ctx.records[upload_doc.input_name+'_url']!='')
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 2,
                                            class: "p-cursor",
                                            onClick: ($event: any) => {_ctx.openDoc(_ctx.records[upload_doc.input_name+'_url']);}
                                          }, [
                                            _createElementVNode("span", { innerHTML: _ctx.svg_image }, null, 8, _hoisted_192),
                                            _createTextVNode(" " + _toDisplayString(upload_doc.name), 1)
                                          ], 8, _hoisted_191))
                                        : _createCommentVNode("", true),
                                      (_ctx.form[upload_doc.input_name+'_pdiv']==1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_193, [
                                            _createElementVNode("div", {
                                              class: "progress-bar bg-dark",
                                              role: "progressbar",
                                              style: _normalizeStyle({'width':_ctx.form[upload_doc.input_name+'_pbar']+'%'}),
                                              "aria-valuenow": _ctx.form[upload_doc.input_name+'_pbar'],
                                              "aria-valuemin": "0",
                                              "aria-valuemax": "100"
                                            }, _toDisplayString(_ctx.form[upload_doc.input_name+'_pbar_p']), 13, _hoisted_194)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_Field, {
                                        rules: _ctx.requiredField,
                                        modelValue: _ctx.form[upload_doc.input_name+'_path'],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.form[upload_doc.input_name+'_path']) = $event),
                                        class: "form-control selected-field",
                                        name: upload_doc.input_name+'_path',
                                        type: "hidden"
                                      }, null, 8, ["rules", "modelValue", "onUpdate:modelValue", "name"]),
                                      _createVNode(_component_ErrorMessage, {
                                        style: {"color":"#d00000"},
                                        name: upload_doc.input_name+'_path'
                                      }, null, 8, ["name"])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_195, [
                          _createElementVNode("div", _hoisted_196, [
                            _createElementVNode("div", _hoisted_197, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_198, [
                              _createElementVNode("button", {
                                onClick: _cache[57] || (_cache[57] = ($event: any) => {_ctx.next_step=5;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_199, [
                              _createElementVNode("button", {
                                onClick: _cache[58] || (_cache[58] = ($event: any) => {_ctx.next_step=200;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Finish ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_200, [
      _createElementVNode("div", _hoisted_201, [
        _createElementVNode("div", _hoisted_202, [
          _createElementVNode("div", _hoisted_203, [
            _createElementVNode("div", _hoisted_204, [
              _hoisted_205,
              _createElementVNode("div", _hoisted_206, [
                _createElementVNode("button", {
                  class: "ok_btn",
                  onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.cancel_request(2)))
                }, "Ok"),
                _createElementVNode("button", {
                  onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.closeModal('cancel_request'))),
                  class: "cancel_btn ml-2"
                }, "Cancel")
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_toasti, { ref: "toasti" }, null, 512)
  ], 64))
}